import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

const useAutoAddQueryString = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const clubDetails = JSON.parse(localStorage.getItem("club_details"));
    const queryParams = {
      game: clubDetails?.id,
      account: clubDetails?.account_name,
    };

    const searchParams = new URLSearchParams();

    Object.entries(queryParams).forEach(([key, value]) => {
      searchParams.append(key, value);
    });

    const queryString = searchParams.toString();

    // Check if the current URL already has the same query string
    if (window.location.search !== `?${queryString}`) {
      navigate(`?${queryString}`, { replace: true });
    }
  }, [navigate]);
};

export default useAutoAddQueryString;
